import { render, staticRenderFns } from "./Statuses_master.vue?vue&type=template&id=75d19a68&"
import script from "./Statuses_master.vue?vue&type=script&lang=js&"
export * from "./Statuses_master.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports